import { useMemo } from "react"
import { hasAnyRole, hasPHCAccessRole, hasRole } from "../utils/rbac"
import { useUser } from "./useUser"

export function useRoles() {
  const user = useUser()
  const roles = user?.roles

  return useMemo(
    () => ({
      hasRole: (role: string) => hasRole(roles, role),
      hasAnyRole: (allowedRoles: readonly string[]) =>
        hasAnyRole(roles, allowedRoles),
      hasPHCAccessRole: () => hasPHCAccessRole(roles),
    }),
    [roles]
  )
}
